import React from 'react';
import { Stack, Tooltip, Typography, Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ClientTagChip from './ClientTagChip';

export default function ClientTagsRow({
  tags = [],
  maxVisible,
  emptyText,
  showEmpty = false,
  sx,
}) {
  const { t } = useTranslation();
  const list = Array.isArray(tags) ? tags.filter((tag) => tag?.name) : [];

  if (list.length === 0) {
    if (!showEmpty || !emptyText) return null;
    return (
      <Typography variant="body2" color="text.secondary" sx={sx}>
        {emptyText}
      </Typography>
    );
  }

  const visible = maxVisible != null && maxVisible > 0 ? list.slice(0, maxVisible) : list;
  const overflow = maxVisible != null && maxVisible > 0 ? list.slice(maxVisible) : [];

  return (
    <Stack direction="row" flexWrap="wrap" gap={0.5} sx={sx}>
      {visible.map((tag) => (
        <ClientTagChip
          key={tag._id || tag.name}
          tag={tag}
          title={tag.source === 'rule' ? t('clients.tags.autoApplied') : undefined}
        />
      ))}
      {overflow.length > 0 && (
        <Tooltip
          title={overflow.map((tag) => tag.name).join(', ')}
          arrow
        >
          <Chip
            label={t('clients.tags.moreTags', { count: overflow.length })}
            size="small"
            variant="outlined"
          />
        </Tooltip>
      )}
    </Stack>
  );
}
